import type { PlotFunction } from "./PlotFunction"

// Base type for common properties
export type BasePlotObject = {
  func: PlotFunction
  stroke_color?: string
  fill_color?: string
  rotation?: number
}
